module.exports = __webpack_public_path__ + "media/images/check-blue-eb7a06d6a8e5b7dfc2c21d272a8dea94.svg";